import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Download, Zap } from 'lucide-react';
export function Closing() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-white py-24 px-6 text-center" data-id="element-60">
      <div className="max-w-3xl mx-auto" data-id="element-61">
        <FadeIn data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-green mb-4" data-id="element-63">
            Puedes seguir buscando información sin rumbo…
          </h2>
          <p className="text-2xl md:text-3xl font-serif text-brand-green/80 mb-6" data-id="element-64">
            O puedes empezar hoy con un sistema claro que te lleve paso a paso.
          </p>

          <p className="text-lg text-brand-text/70 mb-4" data-id="element-65">
            El momento perfecto no existe, pero empezar hoy sí hace la
            diferencia.
          </p>
          <p className="text-xl text-brand-green font-semibold mb-12" data-id="element-66">
            Accede ahora y comienza desde casa.
          </p>

          <Button onClick={goToCheckout} className="text-lg px-12 py-5" data-id="element-67">
            QUIERO ACCESO INMEDIATO AHORA
          </Button>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-68">
            <span className="flex items-center gap-1.5" data-id="element-69">
              <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-70" />
              ACCESO INMEDIATO
            </span>
            <span className="flex items-center gap-1.5" data-id="element-71">
              <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-72" />
              DESCARGA DIGITAL
            </span>
            <span className="flex items-center gap-1.5" data-id="element-73">
              <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-74" />
              COMPRA SEGURA
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}